import { render, staticRenderFns } from "./Handle.vue?vue&type=template&id=6d23240b&"
import script from "./Handle.vue?vue&type=script&lang=js&"
export * from "./Handle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports